import { render } from "./CandidateProfiles.vue?vue&type=template&id=40c54457&scoped=true"
import script from "./CandidateProfiles.vue?vue&type=script&lang=js"
export * from "./CandidateProfiles.vue?vue&type=script&lang=js"

import "./CandidateProfiles.vue?vue&type=style&index=0&id=40c54457&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c54457"]])

export default __exports__